import React, { useEffect, useState } from "react";
import "./references.css";
import { getReferences } from "../Transformations/NewsList";
import Carousel from "react-multi-carousel";

export default function References() {
	const [referenceData, setReferenceData] = useState([]);
	const [viewReference, setViewReference] = useState([]);
	const [selected, setSelected] = useState(1);

	useEffect(() => {
		const fetchData = async () => {
			const data = await getReferences();
			const dummyElement = { logo: "", quote: "", manager: "", name: "" };
			setReferenceData(data.filter((company) => company.manager !== ""));
		};

		fetchData();
	}, []);

	useEffect(() => {
		const dummyElement = { logo: "", quote: "", manager: "", name: "" };
		setViewReference(referenceData.slice(0, 3));
	}, [referenceData]);

	useEffect(() => {
		const intervalId = setInterval(() => {
			handleNextClick();
		}, 3000);

		return () => clearInterval(intervalId);
	}, [viewReference]);

	const handlePreviousClick = () => {
		const currentIndex = referenceData.findIndex(
			(item) => item === viewReference[0]
		);
		setSelected(currentIndex);

		const previousIndex =
			(currentIndex - 1 + referenceData.length) % referenceData.length;

		const updatedViewReference = getWrappedSlice(
			referenceData,
			previousIndex,
			3
		);
		setViewReference(updatedViewReference);
	};

	const handleNextClick = () => {
		const currentIndex = referenceData.findIndex(
			(item) => item === viewReference[0]
		);

		const nextIndex = (currentIndex + 1) % referenceData.length;
		setSelected(nextIndex);

		const updatedViewReference = getWrappedSlice(referenceData, nextIndex, 3);
		setViewReference(updatedViewReference);
	};

	const getWrappedSlice = (array, start, length) => {
		const end = (start + length) % array.length;
		return end < start
			? array.slice(start).concat(array.slice(0, end))
			: array.slice(start, end);
	};

	return (
		<div className="main-fields refer-section">
			<div className="field-hd">
				<h2>Kundenstimmen</h2>
			</div>
			<div className="reference-container">
				<div className="scroll-container">
					<div className="nav-ref">
						<button
							className="scroll-button nav-left"
							onClick={handlePreviousClick}
						></button>
					</div>

					<div className="logo-ref">
						{viewReference.map((company, index) => {
							return (
								<div
									key={index}
									className={
										1 === index ? "cbox selected" : "cbox not-selected"
									}
								>
									<img
										height="100px"
										width="100px"
										src={company.logo}
										alt=""
										className="clogo"
									/>
								</div>
							);
						})}
					</div>
					<div className="nav-ref">
						<button
							className="scroll-button nav-right"
							onClick={handleNextClick}
						></button>
					</div>
				</div>

				<div className="quote-block">
					{viewReference[1] ? (
						<>
							<div className="comp-quote">
								{viewReference[1].quote}
								<div className="pname-quote">
									- {viewReference[1].manager}
									<br />
									{viewReference[1].name}
								</div>

								<div className="pname-company"></div>
							</div>
						</>
					) : (
						""
					)}
				</div>
			</div>
		</div>
	);
}
